import React from "react";
import { StyledContainer } from "./styles";

const PageNotFound: React.FC = () => {
    return <StyledContainer>PAGE NOT FOUND</StyledContainer>;
};

export default PageNotFound;
